import Dialog from "@mui/material/Dialog";
import { styled as muiStyled } from "@mui/material/styles";
import React from "react";
import styled from "styled-components";
import theme from "../../style/theme";
import CloseSmallLineIcon from "../icons/CloseSmallLineIcon/CloseSmallLineIcon";
import { GeneralTextField } from "../text-field/GeneralTextField";
import { DialogFooter } from "./DialogFooter";

const BootstrapDialog = muiStyled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

interface Props {
  specificDate: string;
  dialogTitle: string;
  isLoading: boolean;
  isError: boolean;
  handleChangeInputField: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleClickInitButton: () => void;
  handleClickDialogClose: () => void;
  handleClickConfirmButton: () => void;
}

export const DeleteAllDialogPresenter: React.FC<Props> = ({
  specificDate,
  dialogTitle,
  isLoading,
  isError,
  handleChangeInputField,
  handleClickInitButton,
  handleClickDialogClose,
  handleClickConfirmButton,
}) => {
  return (
    <BootstrapDialog
      onClose={handleClickDialogClose}
      aria-labelledby="customized-dialog-title"
      open={true}
    >
      <FormDialogContainer>
        <TitleContainer>
          <TitleLeftContainer>{dialogTitle}</TitleLeftContainer>
          <TitleRightContianer onClick={handleClickDialogClose}>
            <CloseSmallLineIcon
              width="1.5rem"
              height="1.5rem"
              fill={theme.palette.primitives.gray100}
            />
          </TitleRightContianer>
        </TitleContainer>
        <BodyContainer>
          <SpaceBetweenRaw>
            <FieldContainer>날짜</FieldContainer>
            <GeneralTextField
              placeholder={"2023-01-01"}
              name={"specificDate"}
              value={specificDate}
              onChange={handleChangeInputField}
              width="23.25rem"
              isError={isError}
            />
          </SpaceBetweenRaw>
        </BodyContainer>
        <DialogFooter
          confirmButtonText={"삭제하기"}
          disabled={isLoading}
          onClickInitButton={handleClickInitButton}
          onClickConfirmButton={handleClickConfirmButton}
        />
      </FormDialogContainer>
    </BootstrapDialog>
  );
};

const FormDialogContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 31rem;
  border-radius: 0.5rem;
`;

const TitleContainer = styled.div`
  height: 3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${theme.palette.primitives.black};
`;

const TitleLeftContainer = styled.div`
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1rem;
  color: ${theme.palette.primitives.gray50};
  margin-left: 1.5rem;
`;

const TitleRightContianer = styled.div`
  margin-right: 0.438rem;
  cursor: pointer;
`;

const BodyContainer = styled.div`
  height: 10vh;
  overflow-y: auto;
  padding 2rem;
`;

const SpaceBetweenRaw = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`;

const FieldContainer = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 0.813rem;
  line-height: 1rem;
  color: ${theme.palette.primitives.gray600};
`;
